import { createContext, useContext } from 'react';
import { createAdminWorkspace, type AdminWorkspace } from './gateway';

export const AdminWorkspaceContext = createContext<AdminWorkspace | null>(null);
export const AdminWorkspaceFactoryContext = createContext(createAdminWorkspace);
export function useAdminWorkspace(): AdminWorkspace {
  const workspace = useContext(AdminWorkspaceContext);
  if (!workspace) throw new Error('La sesión administrativa todavía no está disponible.');
  return workspace;
}
